import { Mapper } from "../../../../base/utils/mapper";
import { ConsultOptometryResponseModel } from "../../../../domain/models/consult/consult-optometry-response.model";
import { ConsultOptometryResponseEntity } from "../entities/consult-optometry-response.entity";


export class ConsultOptometryImplementationRepositoryMapper extends Mapper<ConsultOptometryResponseEntity, ConsultOptometryResponseModel> {
    mapFrom(param: ConsultOptometryResponseEntity): ConsultOptometryResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ConsultOptometryResponseModel): ConsultOptometryResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}